const FREE_SHIPPING_THRESHOLD = 9900;

function checkShipping(subtotal) {
  const freeShippingElement = document.querySelector(".free_shipping");

  if (!freeShippingElement) return; // Exit if the element doesn't exist

  const percent = subtotal / (FREE_SHIPPING_THRESHOLD / 100);
  const remaining = Math.round(FREE_SHIPPING_THRESHOLD - subtotal);

  if (subtotal < FREE_SHIPPING_THRESHOLD) {
    freeShippingElement.innerHTML =
      "<div>You're <span>" +
      theme.Currency.formatMoney(remaining, theme.settings.moneyFormat) +
      "</span> from getting <strong>Free Shipping within US*</strong></div><div class='pn-progressbar'><div class='pn-progressbar_ind' style='width:" +
      percent +
      "%'></div></div>";
  } else {
    freeShippingElement.innerHTML =
      "<div><strong>Yay! 🤙🏼</strong> Free Shipping within US*</div><div class='pn-progressbar'><div class='pn-progressbar_ind' style='width:100%'></div></div>";
  }
}

const skateboardTypes = [
  '22" Skateboard',
  '27" Skateboard',
  '29" Skateboard',
  '32" Skateboard',
  '36" Skateboard',
];
const backpackTypes = ['Backpack','Skate Sling'];
const capTypes = ['Cap'];

function fetchCartContents() {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      checkCart(cart);
    })
    .catch((error) => {
      console.error("Error fetching cart details:", error);
    });
}

function checkCart(cart) {
  const hasSkateboard = cart.items.some((item) => skateboardTypes.includes(item.product_type));
  if (hasSkateboard) {
    displayBuyOneGetOne();
  } else {
    hideBuyOneGetOne();
  }
  
  const hasBackpack = cart.items.some((item) => backpackTypes.includes(item.product_type));
  if (hasBackpack) {
    hideBackpack();
  } else {
    displayBackpack();
  }

  const hasCap = cart.items.some((item) => capTypes.includes(item.product_type));
  if (hasCap) {
    hideCap();
  } else {
    displayCap();
  }
}

function displayBuyOneGetOne() {
  const div = document.querySelector(".cart-promo.buy-one-get-one");
  if (div) {
    div.style.display = "block";
  }
}

function hideBuyOneGetOne() {
  const div = document.querySelector(".cart-promo.buy-one-get-one");
  if (div) {
    div.style.display = "none";
  }
}

function displayBackpack() {
  const div = document.querySelector(".cart-promo.backpack");
  if (div) {
    div.style.display = "block";
  }
}

function hideBackpack() {
  const div = document.querySelector(".cart-promo.backpack");
  if (div) {
    div.style.display = "none";
  }
}

function displayCap() {
  const div = document.querySelector(".cart-promo.cap");
  if (div) {
    div.style.display = "block";
  }
}

function hideCap() {
  const div = document.querySelector(".cart-promo.cap");
  if (div) {
    div.style.display = "none";
  }
}

// Select the cart drawer element
const cartDrawer = document.getElementById("CartDrawer");

// Callback function to run when mutations are observed
const observerCallback = function (mutationsList) {
  for (let mutation of mutationsList) {
    // Check if the type of mutation is attributes and if the attribute is class
    if (mutation.type === "attributes" && mutation.attributeName === "class") {
      if (cartDrawer.classList.contains("drawer--is-open")) {
        // Fetch the cart's contents to check for the desired product type
        fetchCartContents();

        // Fetch the cart's subtotal when the drawer is opened and pass it to checkShipping
        const subtotalElementContent = cartDrawer
          .querySelector("[data-subtotal]")
          .textContent.trim();
        const subtotalValue = Math.round(
          parseFloat(subtotalElementContent.replace(/[^0-9.-]+/g, "")) * 100
        ); // Convert the formatted money string to an integer (cents)
        checkShipping(subtotalValue);
      }
    }
  }
};

// Create a MutationObserver instance to watch for changes in the cart drawer
const drawerObserver = new MutationObserver(observerCallback);

// Start observing the cart drawer for changes in its class attribute
drawerObserver.observe(cartDrawer, {
  attributes: true,
  attributeFilter: ["class"],
});

// Select the subtotal element
const subtotalElement = cartDrawer.querySelector("[data-subtotal]");

// Create another MutationObserver instance to watch for changes in the subtotal element
const subtotalObserver = new MutationObserver(observerCallback);
